<template>
  <div class="flex-1 px-6 py-6 overflow-y-auto">
    <div class="pb-4 border-b border-gray-300">
      <h1 class="text-2xl font-semibold text-gray-900">
        จัดการการใช้งาน Webhook
      </h1>
      <p>ตั้งค่าจัดการการใช้งาน Webhook</p>
    </div>

    <!-- Error Message -->
    <div
      v-if="errors.length > 0"
      class="px-4 py-3 rounded-md bg-red-600 bg-opacity-20 flex items-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-red-600"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
      <p class="text-base font-semibold text-red-800 flex-1 px-3">
        {{ errors[0] }}
      </p>
      <button @click="errors = []" type="button" class="focus:outline-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-red-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>
    <!-- End Error Message -->

    <div class="divide-y divide-gray-300">
      <div class="py-4 grid grid-cols-4">
        <label class="text-base font-medium text-gray-700"
          >เปิด / ปิด การใช้งาน Webhook</label
        >
        <div class="flex items-center space-x-2">
          <AppToggleInput
            v-model="customerWebhook.is_enabled"
            @input="handleToggleEnableDisableWebhook"
          />
          <svg
            v-if="loading"
            class="animate-spin h-6 w-6 text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      </div>
      <div class="py-4 grid grid-cols-4">
        <label class="col-span-1 text-base font-medium text-gray-700"
          >การใช้งาน Subscription</label
        >
        <div class="col-span-3">
          <table class="table-auto w-full">
            <thead>
              <tr>
                <th class="pb-1 font-normal text-sm text-left">Subscription</th>
                <th class="pb-1 font-normal text-sm text-left">
                  Receiver Endpoint
                </th>
                <th class="pb-1 px-1 font-normal text-sm text-left">
                  ส่งข้อมูลล่าสุด
                </th>
                <th
                  class="
                    pb-1
                    px-2
                    font-normal
                    text-sm text-left
                    whitespace-nowrap
                  "
                >
                  ข้อมูลค้าง
                </th>
                <th
                  class="
                    pb-1
                    px-1
                    font-normal
                    text-sm text-left
                    whitespace-nowrap
                  "
                >
                  สถานะการใช้
                </th>
                <th class="pb-1 px-1 font-normal text-sm text-left">
                  สถานะการส่ง
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading" class="border-t border-gray-300">
                <td class="py-4 text-center" colspan="4">Loading...</td>
              </tr>
              <template v-else>
                <tr
                  class="border-t border-gray-300"
                  v-for="item in customerWebhookSubscription"
                  :key="item.subscription_uuid"
                >
                  <td class="py-2">{{ item.topic ? item.topic.title : '' }}</td>
                  <td class="py-2">{{ item.webhook }}</td>
                  <td class="py-2 px-1 text-gray-500">
                    {{ item.last_sent_event_at | formatDate }}
                  </td>
                  <td class="py-2 px-2">
                    {{ item.pending_event_count }}
                  </td>
                  <td class="py-2 px-1 whitespace-nowrap">
                    <span
                      :class="`
                      ${
                        item.is_receive_real
                          ? 'bg-green-100 text-green-800 border-green-400'
                          : 'bg-red-100 text-red-800 border-red-400'
                      }
                        text-xs
                        font-medium
                        px-2.5
                        py-0.5
                        rounded-md
                        border
                      `"
                    >
                      {{ item.is_receive_real ? 'เปิดใช้งาน' : 'ปิดการใช้งาน' }}
                    </span>
                  </td>
                  <td class="py-2 px-1 whitespace-nowrap">
                    <div class="flex items-center space-x-2">
                      <AppToggleInput
                        v-model="item.is_active"
                        size="sm"
                        :disabled="item.is_active"
                        @input="
                          handleToggleEnableDisableSubscription($event, item)
                        "
                      />
                      <span
                        :class="`${
                          item.is_active ? 'text-green-600' : 'text-red-600'
                        } font-medium text-sm`"
                      >
                        {{ item.is_active ? 'ปกติ' : 'หยุดการส่ง' }}
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- confirm setting webhook -->
    <AppConfirmWebhookModal
      :show="isConfirmSettingWebhookShow"
      :loading="loading"
      @cancel="onCancelConfirmSettingWebhook"
      @submit="onSubmitConfirmSettingWebhook"
    >
      <template v-slot:message v-if="confirmSettingWebhookData">
        {{ confirmSettingWebhookData }}
      </template>
    </AppConfirmWebhookModal>
    <!-- end confirm setting webhook -->

    <!-- confirm setting subscription -->
    <AppConfirmWebhookModal
      :show="isConfirmSettingSubscriptionShow"
      :loading="loading"
      @cancel="onCancelConfirmSettingSubscription"
      @submit="onSubmitConfirmSettingSubscription"
    >
      <template v-slot:title>ยืนยันการ Setting Subscription</template>
      <template v-slot:message v-if="confirmSettingSubscriptionData">
        {{ confirmSettingSubscriptionData }}
      </template>
    </AppConfirmWebhookModal>
    <!-- end confirm setting subscription -->
  </div>
</template>

<script>
import moment from 'moment'

import AppConfirmWebhookModal from '@/components/AppConfirmWebhookModal'
import AppToggleInput from '@/components/AppToggleInput'

export default {
  name: 'CustomerWebhook',

  components: {
    AppToggleInput,
    AppConfirmWebhookModal,
  },

  data() {
    return {
      loading: false,
      customerWebhook: {
        is_enable: false,
      },
      customerWebhookInit: {
        is_enable: false,
      },
      errors: [],
      isConfirmSettingWebhookShow: false,
      isConfirmSettingSubscriptionShow: false,
      confirmSettingWebhookData: '',
      confirmSettingSubscriptionData: '',
      confirmSubscriptionSelected: null,
    }
  },

  filters: {
    formatDate: function (value) {
      return value ? moment(String(value)).format('DD/MM/YYYY') : ''
    },
  },

  computed: {
    customerWebhookSubscription: {
      get() {
        return this.$store.state.customer.customerWebhookSubscription
      },
      set(value) {
        this.$store.commit('customer/setCustomerWebhookSubscription', value)
      },
    },
  },

  created() {
    this.$store.commit('setMenusCustomerActive', true)

    const uuid = this.$route.params.uuid
    this.fetchDataApi(uuid)
  },

  methods: {
    handleToggleEnableDisableWebhook(value) {
      this.confirmSettingWebhookData = value
        ? 'คุณต้องการเปิดใช้งาน Webhook ?'
        : 'คุณต้องการปิดใช้งาน Webhook ?'

      this.isConfirmSettingWebhookShow = true
    },

    handleToggleEnableDisableSubscription(value, item) {
      this.confirmSettingSubscriptionData = value
        ? 'คุณต้องการเปิดการส่ง Subscription ?'
        : 'คุณต้องการปิดการส่ง Subscription ?'

      this.confirmSubscriptionSelected = item

      this.isConfirmSettingSubscriptionShow = true
    },

    onCancelConfirmSettingWebhook() {
      this.isConfirmSettingWebhookShow = false

      this.customerWebhook.is_enabled = this.customerWebhookInit.is_enabled
    },

    onCancelConfirmSettingSubscription() {
      const subscriptions = this.customerWebhookSubscription.map((item) => {
        if (
          item.subscription_uuid ===
          this.confirmSubscriptionSelected.subscription_uuid
        ) {
          return {
            ...item,
            is_active: !this.confirmSubscriptionSelected.is_active,
          }
        }
        return item
      })

      this.customerWebhookSubscription = subscriptions

      this.isConfirmSettingSubscriptionShow = false

      this.confirmSubscriptionSelected = null
    },

    async onSubmitConfirmSettingWebhook() {
      try {
        this.errors = []

        const customerWebhookUpdate = {
          company_reference_uuid: this.$route.params.uuid,
          is_enabled: this.customerWebhook.is_enabled,
        }

        this.loading = true

        await this.$store.dispatch('customer/configCustomerWebhook', {
          uuid: this.$route.params.uuid,
          body: customerWebhookUpdate,
        })

        const customerWebhook = this.$store.state.customer.customerWebhook
        this.customerWebhook = {
          ...customerWebhook,
        }
        this.customerWebhookInit = {
          ...customerWebhook,
        }

        const notification = {
          type: 'success',
          message: 'Your customer webhook has been updated!',
        }
        this.$store.dispatch('notification/add', notification)
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors.push(
            error.response.data.message || 'Something went wrong.'
          )
        }

        const notification = {
          type: 'error',
          message: 'There was a problem customer webhook has been updated!',
        }
        this.$store.dispatch('notification/add', notification)
      } finally {
        this.loading = false
        this.isConfirmSettingWebhookShow = false
      }
    },

    async onSubmitConfirmSettingSubscription() {
      try {
        this.errors = []

        if (!this.confirmSubscriptionSelected) {
          const uuid = this.$route.params.uuid
          await this.$store.dispatch(
            'customer/fetchCustomerWebhookSubscription',
            {
              company_uuid: uuid,
            }
          )

          this.isConfirmSettingSubscriptionShow = false
          return
        }

        this.loading = true

        await fetch(
          'http://webhooks.ap-southeast-1.elasticbeanstalk.com/api/v1/confirm-subscription-and-resend-events',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              subscription_uuid:
                this.confirmSubscriptionSelected.subscription_uuid,
            }),
          }
        )

        const notification = {
          type: 'success',
          message: 'Your confirm subscription and resend events!',
        }
        this.$store.dispatch('notification/add', notification)
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors.push(
            error.response.data.message || 'Something went wrong.'
          )
        }

        const subscriptions = this.customerWebhookSubscription.map((item) => {
          if (
            item.subscription_uuid ===
            this.confirmSubscriptionSelected.subscription_uuid
          ) {
            return {
              ...item,
              is_active: !this.confirmSubscriptionSelected.is_active,
            }
          }
          return item
        })

        this.customerWebhookSubscription = subscriptions

        const notification = {
          type: 'error',
          message:
            'There was a problem confirm subscription and resend events!',
        }
        this.$store.dispatch('notification/add', notification)
      } finally {
        this.loading = false
        this.isConfirmSettingSubscriptionShow = false
      }
    },

    async fetchDataApi(uuid) {
      try {
        this.loading = true

        const [customer] = await Promise.all([
          this.$store.dispatch('customer/fetchCustomer', uuid),
          this.$store.dispatch('customer/fetchCustomerWebhook', uuid),
          this.$store.dispatch('customer/fetchCustomerWebhookSubscription', {
            company_uuid: uuid,
          }),
        ])

        this.$store.commit('setBreadcrumbs', [
          { text: 'รายชื่อลูกค้า', routeName: 'CustomerList' },
          {
            text: customer.title_th || 'ลูกค้า',
            routeName: 'CustomerWebhook',
          },
          { text: 'จัดการการใช้งาน Webhook', routeName: 'CustomerWebhook' },
        ])

        const customerWebhook = this.$store.state.customer.customerWebhook
        this.customerWebhook = {
          ...customerWebhook,
        }
        this.customerWebhookInit = {
          ...customerWebhook,
        }
      } catch (error) {
        console.log(error.response)

        if (error.response && error.response.status === 404) {
          return
        }

        const notification = {
          type: 'error',
          message: 'There was a problem fetching customer webhook data.',
        }
        this.$store.dispatch('notification/add', notification)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
